import React, { useContext, useEffect, useState } from 'react'
import { AppContext } from 'stores/AppStore'
import { useTranslation } from 'react-i18next'
import { UserContext } from 'stores/UserStore'
import { Button, FlexView, Table, Icon } from 'components/common'
import { IoTrashSharp } from 'react-icons/io5'
import InformationCards from 'containers/management-transport/InformationCards'
import HistoryInformation from 'containers/management-transport/HistoryInformation'
import { TransportContext } from 'stores/ManagementTransportStore'
import styled from 'styled-components'
import AttachCTeModal from 'containers/management-transport/AttachCTeModal'
import { FaRegFilePdf, FaRegFileCode, FaRegFileImage } from 'react-icons/fa'
import DeleteAttachModal from 'containers/management-transport/DeleteAttachModal'
import ChangeStatus from 'containers/management-transport/ChangeStatusModal'
import AttachEvidenceModal from 'containers/management-transport/AttachEvidenceModal'
import { LoadingOverlay } from 'components/common'
import { useHistory } from 'react-router-dom'
import ReportDaily from 'containers/management-transport/ReportDaily'

const Title = styled.div`
    color: #797979;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
`

const CardAttach = styled.div`
    width: calc(100% - 48px); //48px por causa do padding de 24px de cada lado, assim não quebra a tela
    background-color: white;
    elevation: medium;
    border-radius: 16px;
    margin: 8px 0px;
    box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.108), 0px 1.6px 3.6px rgba(0, 0, 0, 0.132);
    padding: 16px 24px;
    display: flex;
    flex-direction: column;
`

const TransportInformation = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const { currentUser } = useContext(UserContext)
  const { setPageSubtitle } = useContext(AppContext)
  const { resultInformation,
    openAttachCTe, setOpenAttachCTe,
    openDeleteAttach, setOpenDeleteAttach,
    openChangeStatus, setOpenChangeStatus,
    openAttachEvidence, setOpenAttachEvidence,
    setIdTransport, idTransport,
    loading,
    getInfoTransport,
    manageAttachments,
    solicitacao, setSolicitacao,
    setMapa,
    setStatus,
    setOrigem,
    setDestino,
    setTransportadora,
    getAttachSGRO,
    openReportDaily, setOpenReportDaily } = useContext(TransportContext)
  // const DEFAULT_URL = "management-transport"
  // eslint-disable-next-line no-unused-vars
  const [title, setTitle] = useState('')
  const [rowAttach, setRowAttach] = useState([])

  useEffect(() => {
    const id = window.localStorage.getItem('id')
    setSolicitacao(window.localStorage.getItem('solicitacao'))
    setIdTransport(id)
    getInfoTransport(id)
    setPageSubtitle(t('transport.pageTitle'))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setPageSubtitle, t, idTransport])

  const getURL = async (row) => {
    if (row.url.includes("smart-mobile/solicitacao-transporte/")) {
      const payload = {
        name: row.name,
        uri: row.url,
        option: 'open'
      }
      await manageAttachments(payload, 'open')
    } else {
      await getAttachSGRO(row.name)
    }
  }

  const validation = (row) => {
    return currentUser.name === row.usuario
  }

  const columns = [
    {
      Header: t('transport.name'),
      accessor: (row) => row.name,
      id: "name",
    },
    {
      Header: t('transport.user'),
      accessor: (row) => row.usuario,
      id: "user",
    },
    {
      Header: t('transport.actions'),
      accessor: (row) => <div style={{ display: 'flex', width: '100%', justifyContent: 'space-evenly' }}>
        {row.name.indexOf('pdf') > -1 ?
          <FaRegFilePdf
            size={25}
            style={{ color: '#6a5cff', cursor: 'pointer' }}
            onClick={() => getURL(row)}
          /> : (row.name.indexOf('png') || row.name.indexOf('jpg')) > -1 ?
            <FaRegFileImage
              size={25}
              style={{ color: '#70e459', cursor: 'pointer' }}
              onClick={() => getURL(row)} />
            : <FaRegFileCode
              size={25}
              style={{ color: '#59CBE4', cursor: 'pointer' }}
              onClick={() => getURL(row)}
            />}
        <IoTrashSharp
          onClick={() => { if (validation(row)) { setRowAttach(row); setOpenDeleteAttach(true) } }}
          size={25}
          style={{ color: validation(row) ? '#FB7171' : '#fcacac' }}
          cursor={validation(row) ? 'pointer' : null}
          title={t('transport.delete')} />
      </div>,
      id: 'acoes'
    }
  ]

  const actions = [
    {
      button: "accept",
      status: "0"
    },
    {
      button: "refuse",
      status: "0"
    },
    {
      button: "attachCTe",
      status: "2"
    },
    {
      button: "sendTransport",
      status: "3"
    },
    {
      button: "collect",
      status: "4"
    },
    {
      button: "waitingUnload",
      status: "5"
    },
    {
      button: "truckUnloaded",
      status: "6"
    },
    {
      button: "attachEvidence",
      status: "7"
    }
  ]



  const getModal = (value, status) => {
    setTitle(value)
    if (status === "2") {
      setOpenAttachCTe(true)
    } else if (status === "7") {
      setOpenAttachEvidence(true)
    } else {
      setOpenChangeStatus(true)
    }
  }

  const goBack = () => {
    setIdTransport('')
    setSolicitacao('')
    setMapa('')
    setStatus('')
    setOrigem('')
    setDestino('')
    setTransportadora('')
    history.push('/management-transport')
  }

  if (loading || resultInformation.length === 0) return (
    <LoadingOverlay visible={loading} />
  )
  return (
    <FlexView flex='1' backgroundColor="background" alignSelf="stretch" padding="15px 2%">
      <FlexView flexDirection='row' width="100%" alignItems="center" justifyContent="space-between">
        <FlexView flexDirection='row' width="100%" alignItems="center" style={{ columnGap: '10px' }} >
          <Icon color='#777777' name='arrow-left' onClick={() => { goBack() }} />
          <Title >{t('transport.requestNumber')}: {solicitacao}</Title>
        </FlexView>
        <FlexView flexDirection='row' width="100%" alignItems="center" justifyContent="flex-end" style={{ columnGap: '10px' }}>
          {resultInformation.status === "7" ?
            <Button onClick={() => { setOpenReportDaily(true) }} backgroundColor='primary' color='white'>{t('transport.reportDaily')}</Button>
            : null}
          {actions.map((item, i) => (
            item.status === resultInformation.status ?
              <Button key={i} onClick={() => getModal(item.button, item.status)} backgroundColor={item.button.indexOf("refuse") > -1 || item.button.indexOf("reverse") > -1 ? 'error' : 'primary'} color='white'>{t(`transport.${item.button}`)}</Button>
              : null
          ))}
          {resultInformation.status !== "0" && resultInformation.status !== "2" && resultInformation.status !== "8" ?
            <Button onClick={() => getModal('reverse', '')} backgroundColor='error' color='white'>{t('transport.reverse')}</Button>
            : null
          }
        </FlexView>
      </FlexView>

      <InformationCards data={resultInformation} />
      <HistoryInformation data={resultInformation.timeline} status={resultInformation.status} />
      <CardAttach>
        <Title>{t('transport.listAttachments')}</Title>
        {resultInformation.attachs.length > 0 ?
          <Table width="100%" columns={columns} data={resultInformation.attachs} sortable elevation="none" borderRadius="card" paginated style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', textAlign: "center" }} ></Table>
          :
          <Title>Não existem anexos para essa solicitação</Title>}
      </CardAttach>
      <AttachCTeModal title={title} data={resultInformation} isOpen={openAttachCTe} onOutsideClick={() => setOpenAttachCTe(false)} />
      <AttachEvidenceModal title={title} isOpen={openAttachEvidence} onOutsideClick={() => setOpenAttachEvidence(false)} />
      <DeleteAttachModal isOpen={openDeleteAttach} onOutsideClick={() => setOpenDeleteAttach(false)} data={rowAttach} />
      <ChangeStatus title={title} status={resultInformation.status} isOpen={openChangeStatus} onOutsideClick={() => setOpenChangeStatus(false)} />
      <ReportDaily title='reportDaily' isOpen={openReportDaily} onOutsideClick={() => setOpenReportDaily(false)} status={resultInformation.status} />
    </FlexView>
  )
}
export default TransportInformation
